/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBorderCornerSquare = createReactComponent("outline", "border-corner-square", "IconBorderCornerSquare", [["path", { "d": "M4 20v-15a1 1 0 0 1 1 -1h15", "key": "svg-0" }]]);

export { IconBorderCornerSquare as default };
//# sourceMappingURL=IconBorderCornerSquare.mjs.map
